<div
  class="offcanvas offcanvas-end"
  data-bs-backdrop="default"
  tabindex="-1"
  id="staticBackdrop"
  aria-labelledby="staticBackdropLabel">
  <div class="offcanvas-header" style="display: flex; align-items: center; gap: 8px;">
    <h1 class="offcanvas-title" id="staticBackdropLabel">Transfer Mandat {{ current_aktenzeichen }}</h1>

    <!-- Prev button -->
    <button
      type="button"
      [disabled]="!hasPrevTransfer"
      (click)="navigatePrevTransfer()"
      class="btn btn-sm btn-outline-secondary"
      style="margin-left: 50px; padding: 4px 10px; line-height: 1;"
      title="Zurück">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" style="width: 22px; height: 22px;">
        <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
      </svg>
    </button>

    <!-- Position label -->
    <span *ngIf="transferPositionLabel" style="font-size: 14px; color: #888; white-space: nowrap;">{{ transferPositionLabel }}</span>

    <!-- Next button -->
    <button
      type="button"
      [disabled]="!hasNextTransfer"
      (click)="navigateNextTransfer()"
      class="btn btn-sm btn-outline-secondary"
      style="padding: 4px 10px; line-height: 1;"
      title="Weiter">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" style="width: 22px; height: 22px;">
        <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
      </svg>
    </button>

    <div style="flex: 1;"></div>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
        <path
          fill-rule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
          clip-rule="evenodd" />
      </svg>
    </button>
  </div>
  <div class="offcanvas-body">
    <router-outlet></router-outlet>
  </div>
</div>

<div class="d-flex">
  <div class="row setting-card-container mx-auto">
    <mat-card class="mat-elevation-z4 w-100">
      <mat-card-title>Transfer</mat-card-title>
      <mat-card-content>
        <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; background: white">
          <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
        </div>

        <div class="filter-toolbar">
          <div class="filter-toolbar-inner">
            <span class="filter-inline-label">Suche:</span>
            <mat-form-field appearance="outline" class="compact-field filter-field">
              <input matInput (keyup)="applyFilter($event)" [(ngModel)]="searchValue" placeholder="" #input />
              <button
                mat-button
                *ngIf="searchValue"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="clearSearch()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <div class="filter-select-wrap" *ngFor="let empfilter of empFilters">
              <select
                class="filter-select"
                [(ngModel)]="empfilter.defaultValue"
                (change)="applyNativeFilter($event, empfilter)">
                <option *ngFor="let op of empfilter.options" [value]="op">{{ op }}</option>
              </select>
            </div>

            <button type="button" class="status-info-btn" (click)="openStatusInfo()" title="Status-Beschreibungen">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px; color: #9ca3af;">info_outline</mat-icon>
            </button>

            <div class="filter-toolbar-spacer"></div>

            <button type="button" class="new-item-btn" (click)="openNewItemWizard()" title="Neuen Eintrag anlegen">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px;">add</mat-icon>
              Neuer Eintrag
            </button>

            <button
              *ngIf="canSeeBulkImport"
              type="button"
              class="new-item-btn"
              (click)="goToBulkImport()"
              title="Bulk-Import (Barcode-Scan)">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; line-height: 18px;">qr_code_scanner</mat-icon>
              Bulk-Import
            </button>

            <div class="split-btn-group" *ngIf="editingAllowed">
              <button
                type="button"
                (click)="doTransfer2Mandate()"
                class="split-btn-main">
                Zu Mandate übertragen
                <span *ngIf="selection.selected.length > 0">({{ selection.selected.length }})</span>
                <span *ngIf="selection.selected.length === 0">(alle)</span>
              </button>
              <button
                type="button"
                (click)="toggleDropdown($event)"
                class="split-btn-toggle">
                <svg viewBox="0 0 20 20" fill="currentColor" class="split-btn-arrow">
                  <path d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" fill-rule="evenodd" />
                </svg>
              </button>
              <div class="split-btn-menu" *ngIf="showDropdown">
                <a (click)="bulkSetTransferStatus(0)">Auf Entwurf setzen</a>
                <a (click)="bulkSetTransferStatus(3)">Auf Ungültig setzen</a>
              </div>
            </div>
          </div>
        </div>

      <div class="example-container">
        <app-empty-state
          *ngIf="showNoActiveTransfer"
          title="Keine Transfer-Einträge"
          text="Derzeit sind keine Einträge im Status Transfer vorhanden.">
        </app-empty-state>

        <app-empty-state
          *ngIf="showNoResults"
          title="Keine Einträge gefunden"
          text="Für die aktuelle Suche oder Filterauswahl wurden keine Transfer-Einträge gefunden.">
        </app-empty-state>

        <table
          [hidden]="showEmptyState"
          mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z0"
          matSort
          matSortActive="id"
          matSortDisableClear
          matSortDirection="desc"
          matTableExporter
          #exporter="matTableExporter">
          <!----------------------------------------------------------------- -->

          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 40px; padding: 0 4px;">
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row" style="width: 40px; padding: 0 4px;">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
            <td mat-cell *matCellDef="let row">{{ row.id }}</td>
          </ng-container>

          <!-- transferred STATUS Column -->
          <ng-container matColumnDef="transferred">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Status</th>
            <td mat-cell *matCellDef="let row">
              <div
                *ngIf="row.status_id == '0'"
                data-te-chip-init
                data-te-ripple-init
                class="[word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ENTWURF
              </div>

              <div
                *ngIf="row.status_id == '1'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-approved [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                TRANSFER
              </div>

              <div
                *ngIf="row.status_id == '2'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-success [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ÜBERTRAGEN
              </div>

              <div
                *ngIf="row.status_id == '3'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-invalid [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                UNGÜLTIG
              </div>

              <div
                *ngIf="row.status_id == '9'"
                data-te-chip-init
                data-te-ripple-init
                class="chip-error [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                ERROR
              </div>
            </td>
          </ng-container>

          <!-- Profilbild Column
          <ng-container matColumnDef="profile_image">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-50">&nbsp;</th>
            <td mat-cell *matCellDef="let row">
              <phuture-iavatar src_image="{{ imageStorage }}{{ row.profile_image }}"></phuture-iavatar>
            </td>
          </ng-container>
          -->

          <!-- aktenzeichen Column -->
          <ng-container matColumnDef="aktenzeichen">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">Aktenzeichen</th>
            <td mat-cell *matCellDef="let row" class="font-semibold">&nbsp;{{ row.aktenzeichen }}&nbsp;</td>
          </ng-container>

          <!----------------------------------------------------------------- -->

          <!-- kzland Column -->
          <ng-container matColumnDef="kzland">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Land</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.kzland }}&nbsp;</td>
          </ng-container>

          <!-- kzbezirk Column --
          <ng-container matColumnDef="kzbezirk">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Bezirk</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.kzbezirk }}&nbsp;</td>
          </ng-container>
          -->

          <!-- kznummer Column -->
          <ng-container matColumnDef="kznummer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nummer</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.kznummer }}&nbsp;</td>
          </ng-container>

          <!-- plate Column
          <ng-container matColumnDef="plate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kennzeichen</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.plate }}&nbsp;</td>
          </ng-container>
          -->

          <!-- street Column -->
          <ng-container matColumnDef="street">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Straße</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.street }}&nbsp;</td>
          </ng-container>

          <!-- tat_datum Column -->
          <ng-container matColumnDef="tat_datum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tatdatum</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.tat_datum }}&nbsp;</td>
          </ng-container>

          <!-- tat_zeit Column -->
          <ng-container matColumnDef="tat_zeit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tatzeit</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.tat_zeit }}&nbsp;</td>
          </ng-container>

          <!-- tatbestnr Column
          <ng-container matColumnDef="tatbestnr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tatbestand</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.tatbestnr }}&nbsp;</td>
          </ng-container>
          -->

          <!-- createtime Column
          <ng-container matColumnDef="createtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tatzeit</th>
            <td mat-cell *matCellDef="let row"></td>
          </ng-container>
          -->

          <!-- printcount Column
          <ng-container matColumnDef="printcount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.printcount }}&nbsp;</td>
          </ng-container>
          -->

          <!-- tatbestnr / Delikt Column -->
          <ng-container matColumnDef="tatbestnr">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Delikt</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ parseDelikt(row.tatbestnr) }}&nbsp;</td>
          </ng-container>

          <!-- person Column -->
          <ng-container matColumnDef="person">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Person</th>
            <td mat-cell *matCellDef="let row">&nbsp;{{ row.person }}&nbsp;</td>
          </ng-container>

          <!-- bom Column -->
          <ng-container matColumnDef="bom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-80">BOM</th>
            <td mat-cell *matCellDef="let row">
              <div
                *ngIf="row.bom == 1"
                data-te-chip-init
                data-te-ripple-init
                class="chip-bom [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#4caf50] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#388e3c] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                BOM
              </div>
              <div
                *ngIf="row.bom == 0 || !row.bom"
                data-te-chip-init
                data-te-ripple-init
                class="chip-anzeige [word-wrap: break-word] my-[5px] mr-4 flex h-[32px] cursor-pointer items-center justify-between rounded-[16px] bg-[#2196f3] px-[12px] py-0 text-[13px] font-normal normal-case leading-loose text-white shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#1976d2] dark:bg-neutral-600 dark:text-neutral-200"
                data-te-close="true">
                Anzeige
              </div>
            </td>
          </ng-container>

          <!----------------------------------------------------------------- -->

          <!-- checked Column -->
          <ng-container matColumnDef="checked">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-column-100">Kontrolle</th>
            <td mat-cell *matCellDef="let row">
              <ng-container
                *ngIf="row.errorId !== undefined && row.errorId !== null && row.errorId !== 999 && row.errorId !== 100">
                <mat-icon
                  class="error-icon"
                  matTooltip="{{ row.errorMessage }}"
                  matTooltipPosition="above"
                  class="alert"
                  >error</mat-icon
                >
              </ng-container>

              <ng-container *ngIf="row.errorId == 100">
                <mat-icon matTooltip="In Arbeit" matTooltipPosition="above" class="success">none</mat-icon>
              </ng-container>

              <ng-container *ngIf="row.errorId == 999">
                <mat-icon matTooltip="Alles OK" matTooltipPosition="above" class="success">check</mat-icon>
              </ng-container>
            </td>
          </ng-container>

          <!-- actions button bar Column -->

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let row">
              <button
                type="button"
                matRipple
                [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
                  class="text-white text-sm py-1 px-3 rounded"
                  style="background-color: #4358a6;"
                  onmouseover="this.style.backgroundColor='#374a8a'"
                  onmouseout="this.style.backgroundColor='#4358a6'"
                  (click)="showPageDetail(row.id)">
                  Ansehen
              </button>
            </td>
            <td mat-footer-cell *matFooterCellDef="let row">&nbsp;</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let emprow; columns: displayedColumns" (click)="showPageDetail(emprow.id)"></tr>
        </table>

        <mat-paginator
          #paginator
          [hidden]="showEmptyState"
          [length]="totalItems"
          [pageSizeOptions]="pageSizes"
          showFirstLastButtons></mat-paginator>
      </div>
      <p>&nbsp;</p>
      <p>&nbsp;</p>

      <!--
      <button
        type="button"
        mat-raised-button
        matRipple
        (click)="checkTransfer()"
        [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
        class="bg-blue-400 hover:bg-blue-700 text-white py-2 px-4"
        [style]="{ 'margin-left': '.5em' }">
        1. Kontrolle
      </button>
      &nbsp; &nbsp;

      <br />
      <p>&nbsp;</p>

      <div *ngIf="checking" class="checkJournal">
        <p id="checkJournal" [innerHTML]="checkJournal"></p>
      </div>

      <div *ngIf="errorsFound">
        <p class="alert">Es wurden Fehler gefunden. Die fehlerhaften Datensätze werden nicht übertragen.</p>
      </div>
      <p>&nbsp;</p>

      <button
        type="button"
        matRipple
        *ngIf="isChecked"
        [disabled]="!isChecked"
        [ngClass]="isChecked ? '  ' : 'disabled'"
        (click)="doTransfer2Mandate()"
        [matRippleColor]="'rgb(103, 121, 189, 0.5)'"
        class="bg-blue-400 hover:bg-blue-700 text-white py-2 px-4"
        [style]="{ 'margin-left': '.5em' }">
        2. &Uuml;berf&uuml;hren zu Mandate
      </button>

      <p>&nbsp;</p>

      <div *ngIf="transferSuccess">
        <p class="success">Transfer Einträge wurden erfolgreich zu Mandate übertragen.</p>
      </div>
      <p>&nbsp;</p>
      -->
      </mat-card-content>
    </mat-card>
  </div>
</div>
